import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export default function addFavorite(uId, id, type) {
  return new Promise((resolve, reject) => {
    authToken(uId)
      .then((token) => {
        axios
          .patch(
            // eslint-disable-next-line no-undef
            `${cfac22('API_HOST_V2')}/users/favorites`,
            {
              payload: { id, type },
            },
            { headers: { authorization: `Bearer ${token}`, 'Full-Url': window.location.href } }
          )
          .then((result) => {
            // console.log("RESULT_ADD_FAVORITES: ", result);
            resolve(result.data);
          })
          .catch((error) => {
            //console.log("ERROR_ADD_FAVORITES: ", error);
            return reject(error);
          });
      })
      .catch((error) => {
        //console.log("ERROR_TOKE:", error);
        reject(error);
      });
  });
}
